import React from 'react';
import { Tooltip } from 'antd';
import { mark, deEmphasis, chrome } from '../../../analytics/vizTokens';

// Ranked horizontal bars for magnitude.
//
// Every bar takes the SAME hue on purpose: these categories are nominal, and
// colouring them by their own value would spend the identity channel
// re-encoding what bar length already shows. `emphasisKey` switches to the
// emphasis form -- one bar in the accent hue, the rest grey -- for when a single
// row is the point.
function BarList({
  rows,
  valueKey = 'value',
  labelKey = 'label',
  formatValue = (v) => v,
  emphasisKey = null,
  renderTooltip = null,
  barHeight = 10,
}) {
  const values = rows.map((r) => Number(r[valueKey]) || 0);
  const max = Math.max(...values, 0);

  return (
    <div className="space-y-2.5">
      {rows.map((row) => {
        const value = Number(row[valueKey]) || 0;
        const pct = max > 0 ? (value / max) * 100 : 0;
        const isEmphasised = emphasisKey == null || row[labelKey] === emphasisKey;
        const body = (
          <div className="group grid grid-cols-[minmax(7rem,11rem)_1fr_auto] items-center gap-3">
            <span className="truncate text-xs text-ink" title={row[labelKey]}>
              {row[labelKey]}
            </span>
            <span
              className="relative block rounded-sm"
              style={{ height: barHeight, backgroundColor: chrome.grid }}
            >
              <span
                className="absolute inset-y-0 left-0 rounded-sm transition-[width] duration-300"
                style={{
                  width: `${Math.max(pct, value > 0 ? 1.5 : 0)}%`,
                  backgroundColor: isEmphasised ? mark : deEmphasis,
                }}
              />
            </span>
            {/* Direct label: the value is always readable without the tooltip. */}
            <span className="text-xs font-semibold tabular-nums text-ink">
              {formatValue(value, row)}
            </span>
          </div>
        );

        return (
          <div key={row.id ?? row[labelKey]}>
            {renderTooltip ? (
              <Tooltip
                styles={{ root: { maxWidth: 'none' } }}
                placement="right"
                title={renderTooltip(row)}
              >
                <div className="cursor-help">{body}</div>
              </Tooltip>
            ) : (
              body
            )}
          </div>
        );
      })}
    </div>
  );
}

export default BarList;
